import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "sweetalert2/dist/sweetalert2.min.css";
import "../components/Table/Table.css";
import TopLoader from "../components/Loader/TopLoader";
import "react-responsive-modal/styles.css";
import { toast } from "react-toastify";
import { new_checklist } from "../api/Users";
import { useNavigate } from "react-router-dom";

const AddActivity = ({ userData, role }) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);

  const [addActivity, setAddActivity] = useState({
    name: "",
    class: "",
    section: "",
    description: "",
    file: "",
  });

  

  const navigate = useNavigate();

  const onSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const formData = new FormData();

    formData.append("name", addActivity.name);
    formData.append("file", addActivity.file);
    formData.append("gm_id", userData.data.gm_id);
    formData.append("category", addActivity.category);
  };

  const today = new Date().toISOString().split("T")[0];
  const handleBack = () => {
    navigate("/all-activity");
  }

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-2 px-md-4">
        <div className="my-5 col-12 d-flex justify-content-between align-items-center">
          <h5 className="">{t("Add New Activity")}</h5>
        </div>

        <form
          onSubmit={(e) => onSubmit(e)}
          id="myform"
          style={{ marginTop: "12px" }}
        >
          <div className="row col-12">
            <div className="col-md-12 d-flex justify-content-start row">
              <div className="col-md-4">
                <label className="form-label">
                  {t("Select Class")}
                  <span className="text-danger"> *</span>
                </label>
                <select
                  name="class"
                  className="common-input form-select"
                  required
                >
                  <option value="">{t("Select Class")}</option>
                  <option value="nursery">{t("Nursery")}</option>
                  <option value="kg">{t("KG")}</option>
                </select>
              </div>
              <div className="col-md-4">
                <label className="form-label">
                  {t("Section")}
                  <span className="text-danger"> *</span>
                </label>
                <select
                  name="section"
                  className="common-input form-select"
                  required
                >
                  <option value="">{t("Select Section")}</option>
                  <option value="A">{t("Section-A")}</option>
                  <option value="B">{t("Section-B")}</option>
                </select>
              </div>
              <div className="col-md-4">
                <label className="form-label">
                  {t("Activity Name")} {<span style={{ color: "red" }}>*</span>}
                </label>
                <input
                  type="text"
                  name="name"
                  value={addActivity.heading}
                  className="form-control"
                  required
                />
              </div>
              <div className="col-md-4 mt-4">
                <label className="form-label">
                  {t("Description")} {<span style={{ color: "red" }}>*</span>}
                </label>
                <textarea
                  type="text"
                  name="description"
                  className="form-control"
                  // required
                />
              </div>
              <div className="col-4 mt-4">
                <label className="form-label text-center">
                  {t("Upload Photo")} {<span style={{ color: "red" }}>*</span>}
                </label>
                <input
                  type="file"
                  name="file"
                  accept=".jpg, .jpeg, .png, .pdf"
                  className="form-control"
                />
              </div>
              <div className="col-4" style={{marginTop:"3.5rem"}}>
                <button type="submit" className="btn btn-primary me-2 col-md-3">
                  {t("Add")}
                </button>
                <button
                  type="reset"
                  className="btn btn-secondary me-2 col-md-3"
                >
                  {t("Reset")}
                </button>
                <button
                  type="button"
                  className="btn btn-danger me-2 col-md-3"
                  onClick={handleBack}
                >
                  {t("Back")}
                </button>
                
              </div>
            </div>
          </div>
          
        </form>
      </div>
    </>
  );
};

export default AddActivity;
